import { createI18n } from 'vue-i18n'

const fileNameToLocaleModuleDict = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json', {
  eager: true,
})

const messages: { [P: string]: Record<string, string> } = {}
Object.entries(fileNameToLocaleModuleDict)
  .map(([fileName, localeModule]) => {
    const fileNameParts = fileName.split('/')
    const fileNameWithoutPath = fileNameParts[fileNameParts.length - 1]
    const localeName = fileNameWithoutPath.split('.json')[0]

    return [localeName, localeModule.default] as const
  })
  .forEach((localeNameLocaleMessagesTuple) => {
    messages[localeNameLocaleMessagesTuple[0]] = localeNameLocaleMessagesTuple[1]
  })

// Функция для получения предпочтительного языка
const getPreferredLanguage = (): string => {
  // Сначала проверяем localStorage
  const savedLanguage = localStorage.getItem('preferred-language')
  if (savedLanguage && messages[savedLanguage]) {
    return savedLanguage
  }

  // Затем проверяем язык браузера
  const browserLanguage = navigator.language.toLowerCase()
  const supportedLanguages = Object.keys(messages)

  // Ищем точное совпадение
  if (supportedLanguages.includes(browserLanguage)) {
    return browserLanguage
  }

  // Ищем частичное совпадение (например, 'en' для 'en-US')
  const languageCode = browserLanguage.split('-')[0]
  const matchedLanguage = supportedLanguages.find((lang) => lang.startsWith(languageCode))
  if (matchedLanguage) {
    return matchedLanguage
  }

  // Возвращаем английский как fallback
  return 'gb'
}

export default createI18n({
  legacy: false,
  locale: getPreferredLanguage(),
  fallbackLocale: 'gb',
  messages,
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
  escapeParameter: true,
  strictMessage: false,
  warnHtmlInMessage: 'off',
})
